<template>
  <div>
    <div :id="'divLargeText' + number">
      <span v-if="value === '#NA#'"
            class="na-grid-cell">
        N/A
      </span>

      <span v-else-if="value === '#NREF#' || ((this.params.data && this.params.column ? this.params.data[this.params.column.colId] === undefined : false) && this.params.nref)"
            class="nref-grid-cell">
        ⠀
      </span>

      <span v-else>{{ gridValue }}</span>
    </div>
    <b-popover :target="'divLargeText' + number"
                triggers="hover"
                ref="popover"
                :placement="placement"
                boundary="window"
                @show="onShow">
      <pre>{{value}}</pre>
    </b-popover>
  </div>
</template>

<script>
export default {
  name: 'LargeTextCellRenderer',
  data () {
    return {
      gridValue: '',
      value: '',
      number: Math.floor(Math.random() * 1000000),
      placement: 'bottomleft'
    }
  },
  created () {
    this.updateGridValue(this.params)
  },
  methods: {
    refresh (params) {
      this.updateGridValue(params)
    },
    updateGridValue (params) {
      let lines = params.value ? params.value.replaceAll('\r', '').split('\n') : null
      // eslint-disable-next-line no-unmodified-loop-condition
      while (lines && lines[0] === '') {
        lines.splice(0, 1)
      }
      this.placement = params.placement || this.placement
      this.gridValue = lines && lines.length ? lines[0] : ''
      this.value = params.value
    },
    onShow (evt) {
      const txtEq = this.value === this.gridValue
      const n = !this.value || this.value === '#NA#' || this.value === '#NREF#'
      const el = this.$el.querySelector('div')
      const offEq = el.offsetWidth === el.scrollWidth
      if (txtEq && (n || offEq)) {
        evt.preventDefault()
      }
    }
  }
}
</script>

<style scoped>
div {
  width: 100%;
}
span.na-grid-cell,
span.nref-grid-cell {
  display: block;
  text-align: center;
  position: relative;
  z-index: 6;
  margin: 0 auto;
  right: 17px;
  height: 100%;
  width: calc(100% + 17px + 17px);
  font-weight: 700;
  overflow: hidden;
}

span.nref-grid-cell {
  background: #2a2a2acb;
}

div.popover {
  max-width: 40vw;
  max-height: 40vh;
}

div.popover-body {
  max-width: 40vw;
  max-height: 40vh;
  overflow-y: auto;
  overflow-x: hidden;
}

div.popover pre {
  overflow-wrap: break-word;
  word-break: break-all;
  white-space: pre-wrap;
  font-size: var(--ag-font-size);
  font-family: "Verdana","Segoe UI","Open Sans",Helvetica,Arial,sans-serif;
  max-height:10rem;
}
</style>



// WEBPACK FOOTER //
// src/views/private/operational/pci/components/LargeTextCellRenderer.vue